'use client';

import { c as _c } from "react/compiler-runtime";
import { type QueryClient, useQuery } from '@tanstack/react-query';
import { getBadgeDetail } from '@src/actions/gamification.actions';
import { useLocale } from '@src/i18n/LocaleProvider';
import { ONE_MINUTE } from '@src/utils/constants.util';
import { instrumentAction } from "@src/utils/instrumentation";
export const BADGE_DETAIL_QUERY_KEY = 'badge-detail' as const;
export function getBadgeDetailQueryKey(id: GamificationApi.Badge['id'] | undefined, slug: string | undefined, locale?: string) {
  return [BADGE_DETAIL_QUERY_KEY, id, slug, locale] as const;
}
export function resetBadgeDetail(queryClient: QueryClient) {
  return queryClient.resetQueries({
    queryKey: [BADGE_DETAIL_QUERY_KEY]
  });
}
export interface UseBadgeDetailArgs {
  badge: GamificationApi.Badge | null;
  enabled?: boolean;
}
export function useBadgeDetail(t0) {
  const $ = _c(13);
  const {
    badge,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const {
    locale
  } = useLocale();
  const id = badge?.id;
  const slug = badge?.slug;
  const status = badge?.status;
  let t2;
  if ($[0] !== id || $[1] !== locale.code || $[2] !== slug) {
    t2 = getBadgeDetailQueryKey(id, slug, locale.code);
    $[0] = id;
    $[1] = locale.code;
    $[2] = slug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id || $[5] !== locale.code || $[6] !== slug || $[7] !== status) {
    t3 = async () => {
      const response = await instrumentAction("GamificationActions.getBadgeDetail", getBadgeDetail)(id, slug, status, locale.code);
      if (!response.badge) {
        throw new Error("Badge detail not found");
      }
      return response.badge;
    };
    $[4] = id;
    $[5] = locale.code;
    $[6] = slug;
    $[7] = status;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = enabled && !!badge && id != null && !!slug;
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: ONE_MINUTE * 5,
      retry: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return useQuery(t5);
}